import { render, staticRenderFns } from "./GewerbeImmobilien.vue?vue&type=template&id=f69e9b74&"
import script from "./GewerbeImmobilien.vue?vue&type=script&lang=js&"
export * from "./GewerbeImmobilien.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports